import React from "react";
import { Card, CardBody } from "@chakra-ui/react";

interface DictionaryBlockProps {
  icon: string;
  title: string;
  subtitle: string | JSX.Element;
  onClick: () => void;
}

const DictionaryBlock: React.FC<DictionaryBlockProps> = ({
  icon,
  title,
  subtitle,
  onClick,
}) => {
  // Determine color based on title
  const getTitleColor = () => {
    switch (title) {
      case "Words":
        return "text-[var(--color-blue)]";
      case "Phrases":
        return "text-[var(--color-green)]";
      default:
        return "";
    }
  };

  // Determine border color based on title
  const getBorderColor = () => {
    switch (title) {
      case "Words":
        return "border-l-4 border-[var(--color-blue)]";
      case "Phrases":
        return "border-l-4 border-[var(--color-green)]";
      default:
        return "";
    }
  };

  return (
    <button onClick={onClick} className="w-full">
      <Card className={`w-full h-auto ${getBorderColor()}`} py={5}>
        <CardBody className="flex flex-col items-start justify-start gap-3 text-start">
          <div className="text-xxl font-semibold">{icon}</div>
          <div className={`text-xl font-bold ${getTitleColor()}`}>{title}</div>
          <div className="text-sm font-normal">{subtitle}</div>
        </CardBody>
      </Card>
    </button>
  );
};

export default DictionaryBlock;
